import template from './service_ticket_parts.create.html';
import controller from './service_ticket_parts.create.controller';
import './service_ticket_parts.create.scss';

const serviceTicketsPartsCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceTicketsPartsCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/create/service_ticket_parts.create.component.js